import { useParams } from 'react-router';

import { CREATE_ROUTE_NAME } from '@/constants';

const useRequestId = (paramName: string = 'uuid') => {
  const params = useParams();

  const requestId: string = params[paramName] || '';

  return {
    uuid: requestId,
    requestId,
    isCreateMode: !requestId || requestId === CREATE_ROUTE_NAME
  };
};

export default useRequestId;
